// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/square-pen.js';

import { paths } from '../generated/square-pen';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('square-pen', Original, paths);
